import { useContext } from 'react';
import { FormattedMobile } from '../../common/utils/formatters';
import { UserContext } from '../../contexts';
import { DisplayTable, DisplayTableHead, DisplayTableRow } from '../molecules';
import type { TUser } from '../types';

type TMerchantUsersList = {
  merchantUsers: ReadonlyArray<TUser>;
  refreshPage: () => void;
};
const MerchantUsersList = ({
  merchantUsers,
  refreshPage
}: TMerchantUsersList) => {
  const { user } = useContext(UserContext);
  const merchantId = user.merchantId;
  // TODO log
  // console.log('MerchantUsersList', merchantId);
  // console.log('userContext:', JSON.stringify(user, null, 2));
  return (
    <>
      <DisplayTable
        colWidths={['190px', '154px', '154px', '180px', 'auto']}
        colWidthsMd={['12rem', '11rem', '7.5rem', '8.3rem', 'auto']}
      >
        <DisplayTableHead
          cols={['Name', 'Title', 'Portal Role', 'Phone', 'Email']}
        />
        {merchantUsers.length > 0 ? (
          merchantUsers.map((v: TUser, index: number) => {
            const modalUserContent = {
              userId: v.id,
              accountLocked: v.accountLocked,
              accountArchived: v.accountArchived,
              fullName: v.name,
              title: v.title,
              email: v.email,
              mobile: v.mobile,
              role: v.role,
              readOnly: v.permissions.readOnlyAccess,
              pas: v.permissions.paymentAssistAgreement,
              emailNotifications: v.emailPreferences.enableAllNotifications,
              merchantId: v.merchantId ? v.merchantId : undefined
            };

            return (
              <DisplayTableRow
                key={`${index}-${v.id}`}
                type="modal"
                cells={[
                  {
                    contentType: 'text',
                    content: v.name
                  },
                  {
                    contentType: 'text',
                    content: v.title
                  },
                  {
                    contentType: 'text',
                    content: v.role
                  },
                  {
                    contentType: 'text',
                    content: <FormattedMobile mobile={v.mobile} />
                  },
                  {
                    contentType: 'text',
                    content: v.email
                  }
                ]}
                modalType="tenant_user"
                modalTitle="User"
                modalUserContent={modalUserContent}
                refreshPage={refreshPage}
              />
            );
          })
        ) : (
          <DisplayTable colWidths={['auto']} colWidthsMd={['auto']}>
            <DisplayTableRow
              type="div"
              cells={[
                {
                  contentType: 'error',
                  content: 'No Users found'
                }
              ]}
            />
          </DisplayTable>
        )}
      </DisplayTable>
    </>
  );
};

export { MerchantUsersList };
